import { z } from 'zod';
import { StoreCode, storeCodeSchema } from '../../../schema/storeCode';

const { us, eu, uk, qa, ukd, eud } = storeCodeSchema.enum;

export const referFriendsButtonIdSchema = z.enum(['friendbuyoverlay']);

export const referFriendsBoardIdSchema = z.enum([
  'AGEUEnglishDashboard', // portal, lang en and store eu
  'AGDEEnglishDashboard', // portal, lang de and store eu
  'AGUKEnglishDashboard', // portal, lang en and store uk
  'AGEnglishDashboard', // portal, lang en and any store (default)

  'ageuenglishlandingpage', // landing page, lang en and store eu
  'aggermanlandingpage', // landing page, lang de and store eu or uk
  'AGUKenglishlandingpage', // landing page, lang en and store uk
  'agenglishlandingpage' // landing page, lang en and any store (default)
]);

export const FRIENDBUY_MERCHANT_ID: Readonly<Partial<Record<StoreCode, string>>> = {
  [us]: '4629a8d1-3a8f-48e3-a181-9b8be80059d6',
  [eu]: 'c0e30aab-a74e-4405-96b4-91684978317a',
  [uk]: '257f8786-9721-4092-90ab-e194ac3ba387',
  [qa]: 'efa62efe-09b6-47d6-b022-faca68609602',
  [ukd]: '257f8786-9721-4092-90ab-e194ac3ba387',
  [eud]: 'c0e30aab-a74e-4405-96b4-91684978317a'
  // dev is not set up with Refer-a-friend on upscribe
};
